var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"traffic"},[(_vm.guide == '')?_c('div',[_c('el-empty',{attrs:{"description":"没有内容额"}})],1):_c('div',[_c('img',{staticClass:"guideImg",attrs:{"src":_vm.guide}})])])}
var staticRenderFns = []

export { render, staticRenderFns }